var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inline-block font-normal relative",class:[
    _vm.underline ? 'border-illinois-bg-card  ' : 'border-illinois-primary'
  ],style:([
    {
      borderBottomWidth: _vm.underline ? '0px' : _vm.borderTickens + 'px'
    }
  ])},[_c('div',{staticClass:"relative",class:[
      _vm.hasEdgeOffsetOnMobile ? 'md:px-0 px-2.5' : '',
      !_vm.hasEdgeOffsetOnMobile && _vm.paddingLeft === null && _vm.paddingRight === null
        ? 'px-2.5'
        : ''
    ],style:({
      paddingLeft:
        _vm.paddingLeft !== null
          ? typeof _vm.paddingLeft === 'string'
            ? _vm.paddingLeft
            : _vm.paddingLeft + 'px'
          : undefined,
      paddingRight:
        _vm.paddingRight !== null
          ? typeof _vm.paddingRight === 'string'
            ? _vm.paddingRight
            : _vm.paddingRight + 'px'
          : undefined
    })},[_c('div',{ref:"tabsContainer",staticClass:"flex overflow-x-scroll scrollbar-hide relative",class:[_vm.centerTabs ? 'justify-center' : ''],style:({
        gap:
          _vm.itemGap !== null
            ? typeof _vm.itemGap === 'string'
              ? _vm.itemGap
              : _vm.itemGap + 'px'
            : _vm.underline
            ? '20px'
            : '4px'
      }),on:{"&scroll":function($event){return _vm.onScroll.apply(null, arguments)}}},[(!_vm.loading)?[_vm._l((_vm.items),function(item,index){return _c('button',{key:index,staticClass:"outline-none focus:outline-none min-h-45 relative flex-shrink-0",class:[
            item && item.disabled && _vm.activeTab !== item.value
              ? 'cursor-not-allowed pointer-events-none'
              : ''
          ],attrs:{"disabled":item && item.disabled && _vm.activeTab !== item.value},on:{"click":function($event){!(item && item.disabled) && _vm.selectTab(item.value)}}},[_c('div',{ref:"itemRefs",refInFor:true,staticClass:"outline-none focus:outline-none flex items-center justify-center relative z-30",class:[
              _vm.underline ? 'min-h-3 py-3' : 'px-2.5 h-7 rounded-full',
              item && item.disabled && _vm.activeTab !== item.value
                ? 'opacity-50'
                : '',
              _vm.$scopedSlots.icon ? 'flex-col' : ''
            ],style:({
              WebkitTransform: 'translateZ(0)',
              transform: 'translateZ(0)',
              ...(_vm.$scopedSlots.icon && !_vm.underline
                ? {
                    paddingLeft: index === 0 ? '0' : '12px',
                    paddingTop: '14px',
                    paddingRight: index === _vm.items.length - 1 ? '0' : '12px',
                    paddingBottom: '13px'
                  }
                : {})
            })},[(_vm.$scopedSlots.icon)?_c('div',{staticClass:"flex items-center justify-center mb-1"},[_vm._t("icon",null,{"item":item})],2):_vm._e(),_c('span',{ref:"labelRefs",refInFor:true,class:[
                'font-medium',
                _vm.size === 'xs' ? 'text-xs' : 'text-sm',
                _vm.$scopedSlots.icon
                  ? 'truncate block text-center max-w-75 mx-auto'
                  : 'whitespace-nowrap',
                _vm.uppercase ? 'uppercase' : '',
                _vm.activeTab === item.value
                  ? _vm.darkText
                    ? _vm.underline
                      ? 'text-illinois-primary'
                      : 'text-illinois-text'
                    : 'text-illinois-text '
                  : _vm.darkText
                  ? 'text-illinois-bg-odds'
                  : 'text-illinois-text-muted'
              ]},[_vm._v(" "+_vm._s(_vm.formatLabel(item.label))+" ")])])])}),_vm._t("right")]:_vm._l((_vm.skeletonItems),function(w,idx){return _c('button',{key:idx,staticClass:"outline-none focus:outline-none min-h-45 relative flex-shrink-0 cursor-default z-10",attrs:{"disabled":""}},[_c('div',{staticClass:"outline-none focus:outline-none flex items-center justify-center relative",class:[
              _vm.underline ? 'min-h-3 py-3' : 'px-2.5 h-7 rounded-full',
              _vm.showIconSkeleton ? 'flex-col' : ''
            ]},[(_vm.showIconSkeleton)?_c('div',{staticClass:"w-4 h-4 bg-illinois-white-20 rounded-full mb-1 shimmer text-illinois-white-40"}):_vm._e(),_c('div',{staticClass:"rounded bg-illinois-white-20 shimmer text-illinois-white-40",style:({
                height: _vm.size === 'xs' ? '12px' : '14px',
                width: w + 'px'
              })})])])}),(_vm.underline && !_vm.loading)?_c('div',{staticClass:"absolute bottom-0 left-0 z-20 transition-all duration-300 ease-in-out p-0 pointer-events-none",class:[_vm.darkText ? 'bg-illinois-primary' : 'bg-illinois-text'],style:({
          width: _vm.indicatorWidthPx + 'px',
          height: _vm.activeTabTickens + 'px',
          WebkitTransform:
            'translate3d(' +
            (_vm.indicatorLeftPx + _vm.underlineOffsetPx) +
            'px, 0, 0)',
          transform:
            'translate3d(' +
            (_vm.indicatorLeftPx + _vm.underlineOffsetPx) +
            'px, 0, 0)',
          willChange: 'transform, width'
        })}):(!_vm.underline && !_vm.loading)?_c('div',{staticClass:"absolute top-1/2 left-0 z-0 rounded-full bg-illinois-primary transition-all duration-300 ease-in-out pointer-events-none",style:({
          width: _vm.indicatorWidthPx + _vm.pillPaddingX * 2 + 'px',
          height: Math.max(_vm.indicatorHeightPx + _vm.pillPaddingY * 2, 28) + 'px',
          transform:
            'translate(' + (_vm.indicatorLeftPx - _vm.pillPaddingX) + 'px, -50%)',
          willChange: 'transform, width, height'
        })}):_vm._e()],2),(!_vm.loading && _vm.canScrollLeft)?_c('button',{staticClass:"absolute left-0 top-0 z-30 flex items-center justify-start text-illinois-text-muted hover:text-illinois-text transition-all duration-200 outline-none focus:outline-none pointer-events-auto pl-2",style:({
        height: _vm.underline ? '100%' : '28px',
        width: '48px',
        backgroundImage: _vm.darkText
          ? 'linear-gradient(to right, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.5) 30%, rgba(255, 255, 255, 0.2) 60%, transparent 100%)'
          : 'linear-gradient(to right, var(--bg-dark-color) 0%, color-mix(in srgb, var(--bg-dark-color) 70%, transparent) 30%, color-mix(in srgb, var(--bg-dark-color) 40%, transparent) 60%, transparent 100%)'
      }),on:{"click":_vm.scrollLeft}},[_c('IllinoisIcons',{attrs:{"icon":"chevron-left","width":16,"height":16}})],1):_vm._e(),(!_vm.loading && _vm.canScrollRight)?_c('button',{staticClass:"absolute right-0 top-0 z-30 flex items-center justify-end text-illinois-text-muted hover:text-illinois-text transition-all duration-200 outline-none focus:outline-none pointer-events-auto pr-2",style:({
        height: _vm.underline ? '100%' : '28px',
        width: '48px',
        backgroundImage: _vm.darkText
          ? 'linear-gradient(to left, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.5) 30%, rgba(255, 255, 255, 0.2) 60%, transparent 100%)'
          : 'linear-gradient(to left, var(--bg-dark-color) 0%, color-mix(in srgb, var(--bg-dark-color) 70%, transparent) 30%, color-mix(in srgb, var(--bg-dark-color) 40%, transparent) 60%, transparent 100%)'
      }),on:{"click":_vm.scrollRight}},[_c('IllinoisIcons',{attrs:{"icon":"chevron-right","width":16,"height":16}})],1):_vm._e()]),(_vm.underline && _vm.borderTickens > 0)?_c('div',{staticClass:"absolute left-0 right-0 z-10",class:[_vm.darkText ? 'bg-illinois-text-muted' : 'bg-illinois-border'],style:({ bottom: '0px', height: _vm.borderTickens + 'px' })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }